/* =================================================================
   4. i18n
   ================================================================= */
const I18N = {
  en: {
    "demo.cta": "Demo",
    "auth.signin": "Sign in",
    "auth.register": "Start free",
    "picker.pickFree.btn":   "Pick 4 free",
    "picker.pickFree.toast": "Selected 4 best free models. Add Groq + OpenRouter API keys in Settings to run them.",
    /* ----- Auth pages (login / register / forgot / reset / verify / account / pricing) ----- */
    "auth.login.eyebrow":      "ACCOUNT · SIGN IN",
    "auth.login.title":        "Sign in",
    "auth.login.sub":          "Welcome back. Use your AI Board account to continue.",
    "auth.login.submit":       "Sign in",
    "auth.login.forgot":       "Forgot password?",
    "auth.login.no_account":   "New here?",
    "auth.login.register_cta": "Create account",
    "auth.register.eyebrow":      "ACCOUNT · NEW",
    "auth.register.title":        "Create your account",
    "auth.register.sub":          "14-day Pro trial. No card. Cancel anytime.",
    "auth.register.submit":       "Create account",
    "auth.register.terms":        "I accept the Terms and Privacy Policy",
    "auth.register.have_account": "Have an account?",
    "auth.register.signin_cta":   "Sign in",
    "auth.forgot.eyebrow": "ACCOUNT · RECOVERY",
    "auth.forgot.title":   "Forgot password",
    "auth.forgot.sub":     "We'll email you a one-time link to reset it.",
    "auth.forgot.submit":  "Send reset link",
    "auth.forgot.back":    "Back to sign in",
    "auth.reset.eyebrow": "ACCOUNT · RESET",
    "auth.reset.title":   "Set a new password",
    "auth.reset.sub":     "Pick a new password. At least 8 characters.",
    "auth.reset.submit":  "Set new password",
    "auth.reset.back":    "Back to sign in",
    "auth.verify.eyebrow":       "ACCOUNT · EMAIL VERIFY",
    "auth.verify.pending_title": "Verifying…",
    "auth.verify.pending_sub":   "Check the link in the email we just sent you.",
    "auth.verify.continue":      "Continue to AI Board",
    "auth.verify.go_signin":     "Sign in",
    "auth.verify.go_register":   "Create an account",
    "auth.account.eyebrow":         "ACCOUNT",
    "auth.account.title":           "Account",
    "auth.account.sub":             "Your account, your data, your control.",
    "auth.account.loading_title":   "One moment",
    "auth.account.loading_sub":     "Loading your account…",
    "auth.account.meta":            "Account details",
    "auth.account.row.email":       "Email",
    "auth.account.row.name":        "Name",
    "auth.account.row.tier":        "Plan",
    "auth.account.row.status":      "Status",
    "auth.account.row.verified":    "Email verified",
    "auth.account.row.renews":      "Renews",
    "auth.account.manage":          "Manage subscription",
    "auth.account.pricing":         "See pricing",
    "auth.account.history":         "Interaction history",
    "auth.account.resend":          "Resend verification",
    "auth.account.resend_long":     "Resend verification email",
    "auth.account.change_password": "Change password",
    "auth.account.logout":          "Log out",
    "auth.account.verify_strong":   "Verify your email",
    "auth.account.verify_msg":      "Verify your email to start your 14-day trial.",
    "auth.pricing.eyebrow": "PRICING",
    "auth.pricing.title":   "Plans",
    "auth.pricing.sub":     "Free demo forever. Real BYOK starts at Pro.",
    "auth.pricing.loading": "Loading plans…",
    "auth.pricing.monthly": "Monthly",
    "auth.pricing.yearly":  "Yearly",
    "auth.pricing.save":    "Save ~17%",
    "auth.pricing.note":    "BYOK keys never leave your browser. Cancel anytime.",
    "auth.field.email":            "Email",
    "auth.field.password":         "Password",
    "auth.field.new_password":     "New password",
    "auth.field.confirm_password": "Confirm password",
    "auth.field.display_name":     "Name (optional)",
    "footer.byok_short": "BYOK — keys never leave your browser.",
    "brand.product": "Compare",
    "hero.eyebrow": "Lorenza · Compare Surface",
    "hero.title.1": "Compare.",
    "hero.title.2": "Synthesize.",
    "hero.title.3": "Decide.",
    "hero.subtitle": "One inbox for every model. Run multiple AI engines in parallel, then merge their best insight into one unified answer — with the model and method of your choice.",
    "hero.tag": "Intelligence · Strategy · Value · Efficiency",
    "hero.caption": "AI Agents · Working to get value for you",
    "picker.title": "Models · Constellation",
    "picker.selected": "selected",
    "picker.empty": "No models selected — click a node",
    "picker.hint": "Click a node to select. Selected models orbit closer to the iris.",
    "prompt.title": "Prompt",
    "prompt.placeholder": "Ask anything. The same prompt will be sent to every selected model.",
    "prompt.chars": "chars",
    "prompt.hint": "to run",
    "prompt.run": "Run",
    "prompt.open": "Open",
    "prompt.save": "Save",
    "prompt.loaded": "Loaded {name}",
    "prompt.loadfail": "Could not read file",
    "prompt.toobig": "File too large — max 1 MB",
    "export.txt": "Plain text",
    "responses.title": "Responses",
    "synth.title": "Synthesis · Consolidate",
    "synth.meta": "Choose how & with which model",
    "synth.mode.label": "Synthesis mode (how)",
    "synth.with.label": "Synthesizer model (with)",
    "synth.button": "Synthesize",
    "synth.empty": "Pick a synthesis mode and a model — then merge the strongest insights from each response into one answer.",
    "synth.custom.label": "Custom synthesis instructions",
    "synth.custom.placeholder": "e.g. Synthesize as a board memo: 1 conclusion, 3 risks, 1 recommended next step. Spanish output.",
    "synth.prompt.wrap": "Below are responses from {n} different AI models to the same user prompt.\n\nORIGINAL PROMPT:\n{prompt}\n\nMODEL RESPONSES:\n{responses}\n\nINSTRUCTION:\n{instruction}\n\nDo not list or attribute the models. Output only the synthesized answer.",
    "settings.title": "API Keys · Vault",
    "settings.sub": "Bring your own keys",
    "settings.security_strong": "Local-only.",
    "settings.security": "Your keys are stored only in this browser (localStorage). Each call goes directly from your browser to the provider — never to Lopettia servers.",
    "settings.clear": "Clear all keys",
    "settings.cleared": "All keys cleared",
    "settings.notset": "Not set",
    "settings.set": "Configured",
    "settings.getkey": "Get API key",
    "settings.test": "Test",
    "settings.testing": "Testing…",
    "settings.test.ok": "Connected · {n} models available",
    "settings.test.allok": "All {n} configured models available",
    "settings.test.partial": "{ok} of {total} configured models available",
    "settings.test.missing": "Not available with this key",
    "settings.test.show": "Show all available models",
    "settings.resetspent": "Reset session spend",
    "settings.spent.reset": "Session spend reset to $0",
    "cost.legend": "Cost ladder",
    "cost.session": "Session spend:",
    "cost.total": "Total session",
    "cost.total.tooltip": "Total estimated spend across all models in this browser session",
    "cost.select": "Click to select",
    "cost.deselect": "Click to deselect",
    "cost.disclaimer": "Spend is estimated from public pricing × token usage. Real account balance is only visible in each provider's billing console.",
    "autosave.heading":       "Session autosave",
    "autosave.help":          "When on, your prompt + responses + synthesis are saved automatically after every fan-out, synthesis, and export.",
    "autosave.cloud_label":   "Save to cloud",
    "autosave.cloud_help":    "One daily blob in your cloud history — overwrites in place, no quota spam.",
    "autosave.cloud_on":      "Cloud autosave enabled — first save will fire on the next interaction.",
    "autosave.cloud_off":     "Cloud autosave disabled.",
    "autosave.cloud_quota":   "Cloud autosave paused: storage quota reached.",
    "autosave.local_label":   "Save to local file",
    "autosave.local_help":    "You pick the .json file once; every interaction silently overwrites it. Chrome/Edge only.",
    "autosave.local_on":      "Local autosave enabled — you'll be asked to pick a file on the next interaction.",
    "autosave.local_off":     "Local autosave disabled.",
    "autosave.local_unsupported": "Local autosave needs Chrome or Edge. Use cloud autosave or save manually.",
    "attach.tooltip":         "Attach files (text, Word, PowerPoint, PDF, images)",
    "attach.button":          "Attach",
    "attach.added":           "Attached {count} file(s).",
    "attach.too_big":         "{name} is bigger than {max} — skipped.",
    "attach.docx_failed":     "Could not read {name}.",
    "attach.pptx_failed":     "Could not read {name}.",
    "attach.clear_all":       "Clear all",
    "mic.tooltip":            "Dictate the prompt (Chrome/Edge/Safari)",
    "mic.tooltip_stop":       "Stop dictation",
    "mic.button":             "Dictate",
    "mic.button_stop":        "Stop",
    "mic.unsupported":        "Voice dictation needs Chrome, Edge, or Safari.",
    "mic.permission_denied":  "Microphone permission denied. Enable it in the browser and retry.",
    "mic.network":            "Voice recognition network error. Check your connection and retry.",
    "mic.error":              "Voice recognition failed",
    "footer.note": "BYOK — your keys never leave this browser. Calls go directly to each provider.",
    "err.nomodels": "Select at least one model.",
    "err.noprompt": "Enter a prompt first.",
    "err.nokey": "No API key for {provider}. Open Settings to add one.",
    "err.nocustom": "Enter custom synthesis instructions, or pick another mode.",
    "err.lowbalance": "{provider} account has insufficient credits. Add a payment method or top up your balance to continue.",
    "err.invalidkey": "{provider} API key is invalid or revoked. Check Settings and paste a current key.",
    "err.ratelimit": "{provider} rate limit hit. Wait a moment and try again.",
    "err.model": "{provider} reported a model issue: {raw}",
    "err.forbidden": "{provider} denied this request: {raw}",
    "err.fix_link": "Fix this",
    "err.show_raw": "Show raw response",
    "prompt.no_models": "no models",
    "prompt.model": "model",
    "prompt.models": "models",
    "responses.summary": "{ok} of {total} succeeded · {ms}ms",
    "responses.summary.partial": "{ok} of {total} responses",
    "run.this": "Run this model",
    "run.pending": "Pending",
    "run.pending.msg": "Added after the last run. Click below to run this model with the current prompt.",
    "save.this": "Save this response",
    "save.all": "Export all",
    "save.synth": "Export synthesis",
    "export.md": "Markdown",
    "export.docx": "Word document",
    "export.pdf": "PDF document",
    "export.xlsx": "Excel spreadsheet",
    "export.pptx.section": "PowerPoint presentation",
    "export.pptx.detailed": "Detailed (one slide per model)",
    "export.pptx.summary": "Summary (condensed)",
    "export.pptx.executive": "Executive (conclusion only)",
    "export.section.prompt": "Prompt",
    "export.section.responses": "Responses",
    "export.section.synthesis": "Synthesis",
    "export.section.sources": "Source models",
    "export.section.original": "Original Prompt",
    "export.section.optimal": "Optimal Prompt",
    "export.section.optimal.sub": "Reverse-engineered from synthesis mode: {mode}",
    "export.libmissing": "{fmt} export library not loaded — check your internet connection",
    "export.failed": "{fmt} export failed",
    "save.done": "{name} saved",
    "save.all.done": "All responses saved",
    "save.synth.done": "Synthesis saved",
    "save.optimal.done": "Optimal prompt saved",
    "save.nothing": "Nothing to save yet",
    "copy.synth": "Copy",
    "copy.done": "Copied to clipboard",
    "copy.failed": "Copy failed",
    "optimal.title": "Optimal Prompt · Reusable",
    "optimal.meta": "For future single-shot use",
    "optimal.intro": "Lorenza can reverse-engineer the prompt that — used directly with one model — would produce a response close to your synthesis. Save it for future single-shot use, no comparison needed.",
    "optimal.button": "Generate optimal prompt",
    "optimal.generating": "Generating…",
    "optimal.placeholder": "The optimal prompt will appear here. You can edit it before saving or using it.",
    "optimal.edit": "Edit",
    "optimal.editing": "Done",
    "optimal.copy": "Copy",
    "optimal.save": "Save",
    "optimal.use": "Use this prompt",
    "optimal.used": "Loaded into prompt — ready to run",
    /* MAXWELL-Help-ME — guided requirements wizard (Get Smart themed) */
    "maxwell.panel.title": "MAXWELL-Help-ME",
    "maxwell.panel.tagline": "Define the mission. Maxwell guides.",
    "maxwell.mode.nino": "Kid",
    "maxwell.mode.cxo": "CXO",
    "maxwell.back": "Back to Compare",
    "maxwell.cone.label": "Cone of Silence on — your draft stays in this browser.",
    "maxwell.next": "Next →",
    "maxwell.prev": "← Prev",
    "maxwell.skip": "Skip",
    "maxwell.summary.edit": "EDIT",
    "maxwell.summary.fill": "FILL IN",
    "maxwell.tier.1.title": "Why · Vision & Purpose",
    "maxwell.tier.2.title": "Who & What · Users, Scope, Boundaries",
    "maxwell.tier.3.title": "How · Behavior, Logic, Data",
    "maxwell.tier.4.title": "Experience · UX, Flows, Tone",
    "maxwell.tier.5.title": "Stack · Technical Choices",
    "maxwell.tier.6.title": "Validation · Testing & Quality",
    "maxwell.tier.7.title": "Unknowns & Future · Honesty & Iteration",
    "maxwell.tier.1.prompt.cxo": "What pain or inefficiency does this address? Goal in one sentence + measurable success + what this is NOT.",
    "maxwell.tier.1.prompt.nino": "What annoying thing will this fix? One sentence. And what should it NEVER do?",
    "maxwell.tier.2.prompt.cxo": "Primary users + technical level. Top 3-5 must-have features (non-negotiable). 3-5 explicit out-of-scope items.",
    "maxwell.tier.2.prompt.nino": "Who uses it? What 3-5 things must it do? What should it NEVER do?",
    "maxwell.tier.3.prompt.cxo": "Data model (entities + lifecycle), business rules + validation, error/edge cases + recovery strategy.",
    "maxwell.tier.3.prompt.nino": "What things does it remember? Rules: if X, then Y. What happens when something goes wrong?",
    "maxwell.tier.4.prompt.cxo": "Happy path step-by-step. 3+ alternative paths. Tone, design system, accessibility (WCAG 2.1 AA?).",
    "maxwell.tier.4.prompt.nino": "Walk me through the perfect first use, step by step. What if the user changes their mind?",
    "maxwell.tier.5.prompt.cxo": "Frontend, backend, database, hosting, auth, integrations. Or: 'Claude, recommend simplest viable stack'.",
    "maxwell.tier.5.prompt.nino": "What pieces should it be made of? If you don't know, write 'Claude, recommend'.",
    "maxwell.tier.6.prompt.cxo": "Test cases (input → expected output). Performance benchmarks. Monitoring. Rollback plan. Definition of Done.",
    "maxwell.tier.6.prompt.nino": "How do we test this? What 'definition of done' tells us it works?",
    "maxwell.tier.7.prompt.cxo": "Unsure-abouts. Riskiest assumption (validate first). MVP scope, V2 backlog, V3 dreams.",
    "maxwell.tier.7.prompt.nino": "What are you unsure about? Riskiest assumption? What goes in v1, v2, v3?",
    "maxwell.list.add": "Add",
    "maxwell.list.remove": "Remove",
    "maxwell.validation.warn": "Heads up — some required fields are empty:",
    "maxwell.validation.error": "Cannot continue:",
    "maxwell.validation.continue": "Click Next again to advance anyway.",
    "maxwell.out.spec.title": "Requirements Spec",
    "maxwell.out.spec.subtitle": "Generated by MAXWELL-Help-ME — Lorenza · Lopettia.ai",
    "maxwell.out.script.title": "Claude Code Script",
    "maxwell.out.script.subtitle": "Hand to Claude Code · single source of truth · do not skip phases",
    "maxwell.out.copy": "Copy",
    "maxwell.out.copied": "Copied to clipboard",
    "maxwell.out.save": "Save",
    "maxwell.out.empty": "Fill in the tiers above to populate this artifact.",
    "maxwell.out.empty.section": "_(no input)_",
    "maxwell.out.skipped": "(skipped)",
    "maxwell.out.untitled": "untitled-project",
    "maxwell.cmp.button": "Validate via CMP Compare",
    "maxwell.restart": "Start over",
    "maxwell.handoff.toCompare": "Spec sent to Compare — pick models and Run.",
    "maxwell.restart.confirm": "Discard the current wizard draft and start over?",
    "maxwell.restart.done": "Wizard reset. Tier 1 is active.",
    /* Coder101 — entry point to the Lopettia Agentic SDLC platform */
    "coder101.tagline": "Humans set intent · Agents execute · Ops close the loop",
    "coder101.stage.1": "Intent",
    "coder101.stage.2": "Understand",
    "coder101.stage.gate-a": "Gate A",
    "coder101.stage.3": "Implement",
    "coder101.stage.gate-b": "Gate B",
    "coder101.stage.4": "Tests",
    "coder101.stage.gate-f": "Final",
    "coder101.stage.6": "Deploy",
    "coder101.stage.7": "Monitor",
    "coder101.stage.8": "Learn",
    "coder101.legend.ai": "AI agents",
    "coder101.legend.human": "Humans",
    "coder101.legend.ops": "Ops",
    "coder101.cta.express": "Express Intent → MAXWELL-Help-ME",
    "coder101.cta.chat": "Chat with Maxwell",
    "coder101.chat.toast": "Maxwell intake mode loaded — describe your intent above and Run.",
    "coder101.poweredby": "Powered by Lopettia.ai · Agentic SDLC",
    "maxwell.chat.title": "MAXWELL-Help-ME · Chat",
    "maxwell.chat.tagline": "Talk to Maxwell. Maxwell guides.",
    "maxwell.chat.privacy": "Cone of Silence on — the conversation goes straight to your Anthropic account via your BYOK key; nothing stays in Lopettia.",
    "maxwell.chat.placeholder": "Describe your intent…",
    "maxwell.chat.send": "Send",
    "maxwell.chat.typing": "Maxwell is typing…",
    "maxwell.chat.empty": "Start the conversation — describe what you need to build.",
    "maxwell.chat.model": "Powered by Anthropic Claude · BYOK",
    "maxwell.chat.reset": "Reset chat",
    "maxwell.chat.reset.confirm": "Discard the current chat history and start over?",
    "maxwell.chat.error.getkey": "Add your Anthropic key →",
    "cycle.eyebrow": "Agentic SDLC · 8-stage cycle",
    "cycle.title": "The 8 stages of the cycle, in detail",
    "cycle.subtitle": "Each stage has a dedicated screen, a clear owner, and explicit transition rules. THE LOPETTIA INVERSION: humans set intent and govern gates · agents execute · operations close the loop.",
    "cycle.foot.tag": "Mockups · static reference",
    "cycle.foot.note": "Phase 0 of the agentic SDLC forms. §12.1 Maxwell chat is live (use the Coder101 buttons above). Pipeline view, GATE A, GATE B, Final Review, Dashboard, and Onboarding screens land as interactive surfaces in upcoming phases.",
    "cycle.stage.1.meta": "Stage 1 · Human · ~10 min",
    "cycle.stage.1.title": "Express Intent",
    "cycle.stage.1.tagline": "User describes the need to MaxwellHelpMe in natural language.",
    "cycle.stage.1.body": "Two paths: chat with Maxwell (default) or fill the structured MAXWELL-Help-ME form. Both feed the same intake agent and produce the same Intent Brief.",
    "cycle.stage.2.meta": "Stage 2 · AI agent · 15-60s · claude-opus-5",
    "cycle.stage.2.title": "Agent Understands",
    "cycle.stage.2.tagline": "UnderstandingAgent parses the brief and produces a detailed implementation plan.",
    "cycle.stage.2.body": "Output: Markdown plan with proposed architecture (Mermaid diagrams), modules, tech dependencies, identified risks with mitigations, time/cost estimate, testing and rollback plans.",
    "cycle.gate.a.meta": "Gate A · Human · SLA 24h",
    "cycle.gate.a.title": "Plan Validation",
    "cycle.gate.a.tagline": "Reviewer approves, edits, requests changes, or rejects the plan.",
    "cycle.gate.a.body": "Tabs: Plan Markdown · Diagram · Risks · Estimate. Editor with the full plan inline. Decision is logged with reviewer name and IP — every gate is auditable.",
    "cycle.stage.3.meta": "Stage 3 · AI agent · 5-30 min · claude-opus-5",
    "cycle.stage.3.title": "Agent Implements",
    "cycle.stage.3.tagline": "ImplementationAgent generates the deliverable in an isolated Git workspace.",
    "cycle.stage.3.body": "Generates source code, integrations (Oracle EBS, Salesforce, REST APIs), data pipelines, technical documents, or analyses depending on the deliverable type. Every commit is signed.",
    "cycle.gate.b.meta": "Gate B · Human · SLA 48h",
    "cycle.gate.b.title": "Code Review",
    "cycle.gate.b.tagline": "Tech Lead / CTO validates the generated code before testing.",
    "cycle.gate.b.body": "Side-by-side diff viewer (GitHub-PR-style) with linter, security scan, coverage, warnings cards. Reviewer can approve, request inline changes, or reject.",
    "cycle.stage.4.meta": "Stage 4 · AI agent · 5-15 min · claude-sonnet-5",
    "cycle.stage.4.title": "Tests + Docs",
    "cycle.stage.4.tagline": "TestDocAgent generates unit + integration tests and full documentation.",
    "cycle.stage.4.body": "Coverage target ≥80%. Generated docs include: README, API reference, deployment runbook, ADRs for every locked architecture decision.",
    "cycle.gate.f.meta": "Stage 5 · Human · SLA configurable",
    "cycle.gate.f.title": "Final Human Review",
    "cycle.gate.f.tagline": "VP / Director / Risk Officer signs off on deployment readiness.",
    "cycle.gate.f.body": "Success-criteria checklist with badges (PASS / PARTIAL / FAIL). Approver chooses Approve & Deploy, Quick Refine (last-mile fix), or Reject.",
    "cycle.stage.6.meta": "Stage 6 · Ops · ~5 min · claude-sonnet-5",
    "cycle.stage.6.title": "Deploy + Ship",
    "cycle.stage.6.tagline": "DeploymentAgent provisions infrastructure, applies migrations, ships to environment.",
    "cycle.stage.6.body": "Pre-prod gate: smoke tests on staging. Production deploy uses GitOps (ArgoCD) with auto-rollback on health-check failure. Version tagged in Git, manifest signed.",
    "cycle.stage.7.meta": "Stage 7 · Ops · continuous · claude-sonnet-5",
    "cycle.stage.7.title": "Monitor + Observability",
    "cycle.stage.7.tagline": "MonitoringAgent watches OpenTelemetry traces, Prometheus metrics, and audit logs.",
    "cycle.stage.7.body": "Auto-pages on anomaly: p95 latency breach, error-rate spike, KMS error rate, audit-chain integrity break. Slack/PagerDuty alert with traceId for fast triage.",
    "cycle.stage.8.meta": "Stage 8 · Ops · ongoing · claude-haiku-4.5",
    "cycle.stage.8.title": "Learn + Iterate",
    "cycle.stage.8.tagline": "LearningAgent extracts patterns from completed cycles to improve future ones.",
    "cycle.stage.8.body": "Mines reviewer feedback, gate rejection reasons, and post-deploy incidents. Outputs improvements to system prompts (versioned) and recommended patterns for future intents in the same domain.",
    "cycle.intent.empty": "Start the conversation — describe what you need to build or automate.",
    "cycle.intent.ready": "{n} message(s) sent. You can continue to Plan whenever you're ready.",
    "cycle.action.continue.plan": "Continue to Plan",
    "cycle.action.back.intent": "Back to Intent",
    "cycle.action.back.plan": "Back to Plan",
    "cycle.action.back.impl": "Back to Implementation",
    "cycle.action.back.review": "Back to Code Review",
    "cycle.action.back.tests": "Back to Tests + Docs",
    "cycle.action.continue.final": "Continue to Final Review",
    "cycle.action.send.review": "Send to Code Review",
    "cycle.action.approve.plan": "Approve plan & continue",
    "cycle.action.approve.code": "Approve code & continue",
    "cycle.action.request.changes": "Request changes",
    "cycle.action.reject": "Reject",
    "cycle.action.quick.refine": "Quick refine",
    "cycle.action.approve.ship": "🚀 Approve & ship",
    "cycle.plan.empty": "Click \"Generate plan\" to have the agent analyze the chat from Stage 1.",
    "cycle.plan.generating": "UnderstandingAgent is reading the chat and producing the plan…",
    "cycle.plan.generate": "Generate plan",
    "cycle.plan.regenerate": "Re-generate",
    "cycle.plan.reject.confirm": "Reject this plan? You'll have to re-generate or refine it.",
    "cycle.impl.empty": "Click \"Generate implementation\" to produce the deliverable from the approved plan.",
    "cycle.impl.generating": "ImplementationAgent is producing the deliverable…",
    "cycle.impl.generate": "Generate implementation",
    "cycle.impl.regenerate": "Re-generate",
    "cycle.review.empty": "No implementation to review yet.",
    "cycle.review.changes.prompt": "Describe the changes you want the agent to make:",
    "cycle.review.reject.confirm": "Reject this implementation? The cycle will halt at this stage.",
    "cycle.tests.empty": "Click \"Generate tests + docs\" to produce coverage and documentation.",
    "cycle.tests.generating": "TestDocAgent is producing tests and documentation…",
    "cycle.tests.generate": "Generate tests + docs",
    "cycle.tests.regenerate": "Re-generate",
    "cycle.final.summary.intent": "Stage 1 · Intent",
    "cycle.final.summary.plan":   "Stage 2 · Plan",
    "cycle.final.summary.impl":   "Stage 3 · Implementation",
    "cycle.final.summary.review": "Stage 4 · Code Review",
    "cycle.final.summary.tests":  "Stage 5 · Tests + Docs",
    "cycle.final.shipped": "Shipped",
    "cycle.final.shipped.note": "Cycle complete. The bundle is ready for deployment.",
    "cycle.final.shipped.toast": "Cycle approved and shipped.",
    "cycle.final.reject.confirm": "Reject the entire bundle? The cycle ends here.",
    "cycle.final.refine.prompt": "What needs a quick fix before shipping?",
    "cycle.final.ship.confirm": "Approve & ship this bundle?",
    "cycle.reset": "Reset cycle",
    "cycle.reset.confirm": "Discard the current cycle (intent + plan + implementation + tests) and start over?",
    "cycle.reset.done": "Cycle reset.",
    "session.open.btn":            "Open session",
    "session.save.btn":            "Save session",
    "session.empty":               "Nothing to save yet — write a prompt or run a comparison first.",
    "session.saved":               "Session saved.",
    "session.loaded":              "Session loaded.",
    "session.parse_error":         "Could not parse that file — is it a valid AI Board session JSON?",
    "session.invalid":             "That file is not an AI Board session (missing 'format' field).",
    "session.replace_confirm":     "Loading this session will replace your current prompt, models, and responses. Continue?",
    "session.cloud.history":       "Cloud history",
    "session.cloud.save":          "Cloud save",
    "session.cloud_save_name":     "Save this session as:",
    "session.cloud_saved":         "Saved to cloud.",
    "session.cloud_empty":         "No saved sessions yet. Click '☁️ Save' while working to save one.",
    "session.cloud_login_required": "Sign in to enable cloud session history.",
    "session.cloud_quota":         "Storage quota reached. Upgrade to keep saving cloud sessions.",
    "picker.pickPaid.btn":         "Pick 4 paid",
    "picker.pickPaid.toast":       "Selected 4 best paid models. Add the matching provider keys to run.",
  },
  es: {
    "demo.cta": "Demo",
    "auth.signin": "Iniciar sesión",
    "auth.register": "Empezar gratis",
    "picker.pickFree.btn":   "Escoger 4 gratis",
    "picker.pickPaid.btn":   "Escoger 4 de pago",
    "picker.pickFree.toast": "Seleccionados los 4 mejores modelos gratis. Agrega tus llaves de Groq + OpenRouter en Settings para correrlos.",
    "picker.pickPaid.toast": "Seleccionados los 4 mejores modelos de pago. Agrega las llaves correspondientes para correrlos.",
    "session.open.btn":        "Abrir sesión",
    "session.save.btn":        "Guardar sesión",
    "session.empty":           "Nada que guardar — escribe un prompt o corre una comparación primero.",
    "session.saved":           "Sesión guardada.",
    "session.loaded":          "Sesión cargada.",
    "session.parse_error":     "No pude parsear ese archivo — ¿es un JSON de sesión AI Board válido?",
    "session.invalid":         "Ese archivo no es una sesión AI Board (falta el campo 'format').",
    "session.replace_confirm": "Cargar esta sesión va a reemplazar tu prompt, modelos y respuestas actuales. ¿Continuar?",
    "session.cloud.history":       "Historial nube",
    "session.cloud.save":          "Guardar en nube",
    "session.cloud_save_name":     "Guardar esta sesión como:",
    "session.cloud_saved":         "Guardada en la nube.",
    "session.cloud_empty":         "Aún no tienes sesiones guardadas. Haz clic en '☁️ Guardar' mientras trabajas para guardar una.",
    "session.cloud_login_required": "Inicia sesión para activar el historial en la nube.",
    "session.cloud_quota":         "Cuota de almacenamiento llena. Actualiza tu plan para seguir guardando.",
    /* ----- Páginas de auth ----- */
    "auth.login.eyebrow":      "CUENTA · INICIAR SESIÓN",
    "auth.login.title":        "Iniciar sesión",
    "auth.login.sub":          "Bienvenido. Usa tu cuenta AI Board para continuar.",
    "auth.login.submit":       "Iniciar sesión",
    "auth.login.forgot":       "¿Olvidaste la contraseña?",
    "auth.login.no_account":   "¿Nuevo aquí?",
    "auth.login.register_cta": "Crear cuenta",
    "auth.register.eyebrow":      "CUENTA · NUEVA",
    "auth.register.title":        "Crea tu cuenta",
    "auth.register.sub":          "Prueba Pro de 14 días. Sin tarjeta. Cancelas cuando quieras.",
    "auth.register.submit":       "Crear cuenta",
    "auth.register.terms":        "Acepto los Términos y la Política de Privacidad",
    "auth.register.have_account": "¿Ya tienes cuenta?",
    "auth.register.signin_cta":   "Iniciar sesión",
    "auth.forgot.eyebrow": "CUENTA · RECUPERACIÓN",
    "auth.forgot.title":   "Olvidé mi contraseña",
    "auth.forgot.sub":     "Te enviamos un enlace único por email para resetearla.",
    "auth.forgot.submit":  "Enviar enlace",
    "auth.forgot.back":    "Volver a iniciar sesión",
    "auth.reset.eyebrow": "CUENTA · RESET",
    "auth.reset.title":   "Establece una nueva contraseña",
    "auth.reset.sub":     "Elige una nueva contraseña. Mínimo 8 caracteres.",
    "auth.reset.submit":  "Establecer contraseña",
    "auth.reset.back":    "Volver a iniciar sesión",
    "auth.verify.eyebrow":       "CUENTA · VERIFICAR EMAIL",
    "auth.verify.pending_title": "Verificando…",
    "auth.verify.pending_sub":   "Revisa el enlace del email que te enviamos.",
    "auth.verify.continue":      "Continuar a AI Board",
    "auth.verify.go_signin":     "Iniciar sesión",
    "auth.verify.go_register":   "Crear cuenta",
    "auth.account.eyebrow":         "CUENTA",
    "auth.account.title":           "Cuenta",
    "auth.account.sub":             "Tu cuenta, tus datos, tu control.",
    "auth.account.loading_title":   "Un momento",
    "auth.account.loading_sub":     "Cargando tu cuenta…",
    "auth.account.meta":            "Detalles de la cuenta",
    "auth.account.row.email":       "Correo",
    "auth.account.row.name":        "Nombre",
    "auth.account.row.tier":        "Plan",
    "auth.account.row.status":      "Estado",
    "auth.account.row.verified":    "Email verificado",
    "auth.account.row.renews":      "Renueva",
    "auth.account.manage":          "Gestionar suscripción",
    "auth.account.pricing":         "Ver precios",
    "auth.account.history":         "Historial de interacciones",
    "auth.account.resend":          "Reenviar verificación",
    "auth.account.resend_long":     "Reenviar email de verificación",
    "auth.account.change_password": "Cambiar contraseña",
    "auth.account.logout":          "Cerrar sesión",
    "auth.account.verify_strong":   "Verifica tu email",
    "auth.account.verify_msg":      "Verifica tu email para empezar tu prueba de 14 días.",
    "auth.pricing.eyebrow": "PRECIOS",
    "auth.pricing.title":   "Planes",
    "auth.pricing.sub":     "Demo gratis para siempre. BYOK real desde Pro.",
    "auth.pricing.loading": "Cargando planes…",
    "auth.pricing.monthly": "Mensual",
    "auth.pricing.yearly":  "Anual",
    "auth.pricing.save":    "Ahorra ~17%",
    "auth.pricing.note":    "Las llaves BYOK nunca salen del navegador. Cancela cuando quieras.",
    "auth.field.email":            "Correo",
    "auth.field.password":         "Contraseña",
    "auth.field.new_password":     "Nueva contraseña",
    "auth.field.confirm_password": "Confirmar contraseña",
    "auth.field.display_name":     "Nombre (opcional)",
    "footer.byok_short": "BYOK — las llaves nunca salen del navegador.",
    "brand.product": "Compare",
    "hero.eyebrow": "Lorenza · Superficie Compare",
    "hero.title.1": "Compara.",
    "hero.title.2": "Sintetiza.",
    "hero.title.3": "Decide.",
    "hero.subtitle": "Una bandeja para cada modelo. Ejecuta múltiples motores de IA en paralelo y combina lo mejor de cada uno en una sola respuesta unificada — con el modelo y método que tú elijas.",
    "hero.tag": "Inteligencia · Estrategia · Valor · Eficiencia",
    "hero.caption": "Agentes de IA · Trabajando para generar valor",
    "picker.title": "Modelos · Constelación",
    "picker.selected": "seleccionados",
    "picker.empty": "Ningún modelo seleccionado — haz clic en un nodo",
    "picker.hint": "Haz clic en un nodo para seleccionarlo. Los modelos seleccionados orbitan más cerca del iris.",
    "prompt.title": "Prompt",
    "prompt.placeholder": "Pregunta lo que sea. El mismo prompt se enviará a cada modelo seleccionado.",
    "prompt.chars": "caracteres",
    "prompt.hint": "para ejecutar",
    "prompt.run": "Ejecutar",
    "prompt.open": "Abrir",
    "prompt.save": "Guardar",
    "prompt.loaded": "Cargado {name}",
    "prompt.loadfail": "No se pudo leer el archivo",
    "prompt.toobig": "Archivo muy grande — máx. 1 MB",
    "export.txt": "Texto plano",
    "responses.title": "Respuestas",
    "synth.title": "Síntesis · Consolidar",
    "synth.meta": "Elige cómo y con cuál modelo",
    "synth.mode.label": "Modo de síntesis (cómo)",
    "synth.with.label": "Modelo sintetizador (con cuál)",
    "synth.button": "Sintetizar",
    "synth.empty": "Elige un modo de síntesis y un modelo — luego combina lo mejor de cada respuesta en una sola.",
    "synth.custom.label": "Instrucciones personalizadas de síntesis",
    "synth.custom.placeholder": "Ej.: Sintetiza como memo a junta: 1 conclusión, 3 riesgos, 1 próximo paso recomendado. Salida en español.",
    "synth.prompt.wrap": "A continuación se presentan respuestas de {n} modelos de IA distintos al mismo prompt del usuario.\n\nPROMPT ORIGINAL:\n{prompt}\n\nRESPUESTAS DE LOS MODELOS:\n{responses}\n\nINSTRUCCIÓN:\n{instruction}\n\nNo enlistes ni atribuyas los modelos. Devuelve solo la respuesta sintetizada.",
    "settings.title": "Claves API · Vault",
    "settings.sub": "Trae tus propias claves",
    "settings.security_strong": "Solo local.",
    "settings.security": "Tus claves se almacenan solo en este navegador (localStorage). Cada llamada va directamente desde tu navegador al proveedor — nunca a servidores de Lopettia.",
    "settings.clear": "Borrar todas las claves",
    "settings.cleared": "Todas las claves borradas",
    "settings.notset": "Sin configurar",
    "settings.set": "Configurada",
    "settings.getkey": "Obtener clave",
    "settings.test": "Probar",
    "settings.testing": "Probando…",
    "settings.test.ok": "Conectado · {n} modelos disponibles",
    "settings.test.allok": "Todos los {n} modelos configurados están disponibles",
    "settings.test.partial": "{ok} de {total} modelos configurados disponibles",
    "settings.test.missing": "No disponibles con esta clave",
    "settings.test.show": "Ver todos los modelos disponibles",
    "settings.resetspent": "Reiniciar gasto de sesión",
    "settings.spent.reset": "Gasto de sesión reiniciado a $0",
    "cost.legend": "Escala de costo",
    "cost.session": "Gasto de sesión:",
    "cost.total": "Total sesión",
    "cost.total.tooltip": "Gasto estimado total a través de todos los modelos en esta sesión del navegador",
    "cost.select": "Clic para seleccionar",
    "cost.deselect": "Clic para deseleccionar",
    "cost.disclaimer": "El gasto se estima a partir del precio público × tokens usados. El saldo real solo se ve en la consola de billing de cada proveedor.",
    "autosave.heading":       "Autoguardado de sesión",
    "autosave.help":          "Cuando está activo, tu prompt + respuestas + síntesis se guardan automáticamente tras cada fan-out, síntesis y exportación.",
    "autosave.cloud_label":   "Guardar en la nube",
    "autosave.cloud_help":    "Un blob diario en tu historial cloud — sobrescribe en sitio, sin saturar cuota.",
    "autosave.cloud_on":      "Autoguardado en la nube activado — se grabará en la próxima interacción.",
    "autosave.cloud_off":     "Autoguardado en la nube desactivado.",
    "autosave.cloud_quota":   "Autoguardado en la nube pausado: cuota de almacenamiento alcanzada.",
    "autosave.local_label":   "Guardar en archivo local",
    "autosave.local_help":    "Eliges el archivo .json una vez; cada interacción lo sobrescribe en silencio. Solo Chrome/Edge.",
    "autosave.local_on":      "Autoguardado local activado — se te pedirá elegir un archivo en la próxima interacción.",
    "autosave.local_off":     "Autoguardado local desactivado.",
    "autosave.local_unsupported": "El autoguardado local necesita Chrome o Edge. Usa el cloud o guarda manualmente.",
    "attach.tooltip":         "Adjuntar archivos (texto, Word, PowerPoint, PDF, imágenes)",
    "attach.button":          "Adjuntar",
    "attach.added":           "Adjuntados {count} archivo(s).",
    "attach.too_big":         "{name} pesa más de {max} — omitido.",
    "attach.docx_failed":     "No se pudo leer {name}.",
    "attach.pptx_failed":     "No se pudo leer {name}.",
    "attach.clear_all":       "Quitar todos",
    "mic.tooltip":            "Dictar el prompt (Chrome/Edge/Safari)",
    "mic.tooltip_stop":       "Detener dictado",
    "mic.button":             "Dictar",
    "mic.button_stop":        "Detener",
    "mic.unsupported":        "El dictado por voz requiere Chrome, Edge o Safari.",
    "mic.permission_denied":  "Permiso de micrófono denegado. Habilítalo en el navegador e intenta otra vez.",
    "mic.network":            "Error de red en el reconocimiento de voz. Verifica tu conexión e intenta otra vez.",
    "mic.error":              "Falló el reconocimiento de voz",
    "footer.note": "BYOK — tus claves nunca salen de este navegador. Las llamadas van directamente a cada proveedor.",
    "err.nomodels": "Selecciona al menos un modelo.",
    "err.noprompt": "Escribe un prompt primero.",
    "err.nokey": "No hay clave de API para {provider}. Abre Configuración para agregarla.",
    "err.nocustom": "Escribe instrucciones personalizadas o elige otro modo.",
    "err.lowbalance": "La cuenta de {provider} no tiene saldo suficiente. Agrega un método de pago o recarga tu balance para continuar.",
    "err.invalidkey": "La clave de API de {provider} es inválida o fue revocada. Revisa Configuración y pega una clave vigente.",
    "err.ratelimit": "Límite de tasa de {provider} alcanzado. Espera un momento e inténtalo de nuevo.",
    "err.model": "{provider} reportó un problema con el modelo: {raw}",
    "err.forbidden": "{provider} rechazó esta solicitud: {raw}",
    "err.fix_link": "Resolver",
    "err.show_raw": "Ver respuesta cruda",
    "prompt.no_models": "ningún modelo",
    "prompt.model": "modelo",
    "prompt.models": "modelos",
    "responses.summary": "{ok} de {total} con éxito · {ms}ms",
    "responses.summary.partial": "{ok} de {total} respuestas",
    "run.this": "Ejecutar este modelo",
    "run.pending": "Pendiente",
    "run.pending.msg": "Agregado después del último Run. Haz clic abajo para ejecutar este modelo con el prompt actual.",
    "save.this": "Guardar esta respuesta",
    "save.all": "Exportar todas",
    "save.synth": "Exportar síntesis",
    "export.md": "Markdown",
    "export.docx": "Documento Word",
    "export.pdf": "Documento PDF",
    "export.xlsx": "Hoja de Excel",
    "export.pptx.section": "Presentación PowerPoint",
    "export.pptx.detailed": "Detallada (una slide por modelo)",
    "export.pptx.summary": "Resumen (condensada)",
    "export.pptx.executive": "Ejecutiva (solo conclusión)",
    "export.section.prompt": "Prompt",
    "export.section.responses": "Respuestas",
    "export.section.synthesis": "Síntesis",
    "export.section.sources": "Modelos fuente",
    "export.section.original": "Prompt Original",
    "export.section.optimal": "Prompt Óptimo",
    "export.section.optimal.sub": "Ingeniería inversa del modo de síntesis: {mode}",
    "export.libmissing": "Librería de exportación {fmt} no cargada — revisa tu conexión",
    "export.failed": "Falló la exportación a {fmt}",
    "save.done": "{name} guardado",
    "save.all.done": "Todas las respuestas guardadas",
    "save.synth.done": "Síntesis guardada",
    "save.optimal.done": "Prompt óptimo guardado",
    "save.nothing": "Aún no hay nada que guardar",
    "copy.synth": "Copiar",
    "copy.done": "Copiado al portapapeles",
    "copy.failed": "Error al copiar",
    "optimal.title": "Prompt Óptimo · Reutilizable",
    "optimal.meta": "Para uso directo en una sola pasada",
    "optimal.intro": "Lorenza puede hacer ingeniería inversa del prompt que — usado directamente con un solo modelo — produciría una respuesta cercana a tu síntesis. Guárdalo para uso futuro de un solo disparo, sin comparación.",
    "optimal.button": "Generar prompt óptimo",
    "optimal.generating": "Generando…",
    "optimal.placeholder": "El prompt óptimo aparecerá aquí. Puedes editarlo antes de guardarlo o usarlo.",
    "optimal.edit": "Editar",
    "optimal.editing": "Listo",
    "optimal.copy": "Copiar",
    "optimal.save": "Guardar",
    "optimal.use": "Usar este prompt",
    "optimal.used": "Cargado en el prompt — listo para ejecutar",
    /* MAXWELL-Help-ME — wizard guiado de requerimientos (tema Get Smart) */
    "maxwell.panel.title": "MAXWELL-Help-ME",
    "maxwell.panel.tagline": "Define la misión. Maxwell te guía.",
    "maxwell.mode.nino": "Niño",
    "maxwell.mode.cxo": "CXO",
    "maxwell.back": "Volver a Compare",
    "maxwell.cone.label": "Cono del Silencio activo — tu borrador queda solo en este navegador.",
    "maxwell.next": "Siguiente →",
    "maxwell.prev": "← Anterior",
    "maxwell.skip": "Saltar",
    "maxwell.summary.edit": "EDITAR",
    "maxwell.summary.fill": "LLENAR",
    "maxwell.tier.1.title": "Por qué · Visión y Propósito",
    "maxwell.tier.2.title": "Quién y Qué · Usuarios, Alcance, Límites",
    "maxwell.tier.3.title": "Cómo · Comportamiento, Lógica, Datos",
    "maxwell.tier.4.title": "Experiencia · UX, Flujos, Tono",
    "maxwell.tier.5.title": "Stack · Decisiones Técnicas",
    "maxwell.tier.6.title": "Validación · Pruebas y Calidad",
    "maxwell.tier.7.title": "Incógnitas y Futuro · Honestidad e Iteración",
    "maxwell.tier.1.prompt.cxo": "¿Qué dolor o ineficiencia atacas? Objetivo en una frase, cómo medir el éxito y qué NUNCA debe hacer.",
    "maxwell.tier.1.prompt.nino": "¿Qué cosa molesta arregla esto? Una frase, sin rodeos. ¿Y qué NUNCA debería hacer?",
    "maxwell.tier.2.prompt.cxo": "Usuarios principales y nivel técnico. 3-5 must-haves no negociables. 3-5 fuera-de-alcance explícitos.",
    "maxwell.tier.2.prompt.nino": "¿Quién lo usa? ¿Qué 3-5 cosas debe hacer? ¿Qué nunca debe hacer?",
    "maxwell.tier.3.prompt.cxo": "Modelo de datos (entidades + ciclo de vida), reglas y validación, errores y casos límite + estrategia de recuperación.",
    "maxwell.tier.3.prompt.nino": "¿Qué cosas recuerda? Reglas: si X, entonces Y. ¿Qué pasa cuando algo falla?",
    "maxwell.tier.4.prompt.cxo": "Camino feliz paso a paso. 3+ caminos alternativos. Tono, sistema de diseño, accesibilidad (WCAG 2.1 AA?).",
    "maxwell.tier.4.prompt.nino": "Cuéntame el primer uso perfecto, paso a paso. ¿Y si el usuario se arrepiente?",
    "maxwell.tier.5.prompt.cxo": "Frontend, backend, base de datos, hosting, auth, integraciones. O: 'Claude, recomienda el stack más simple viable'.",
    "maxwell.tier.5.prompt.nino": "¿De qué piezas debe estar hecho? Si no sabes, escribe 'Claude, recomienda'.",
    "maxwell.tier.6.prompt.cxo": "Casos de prueba (entrada → salida esperada). Benchmarks. Monitoreo. Plan de rollback. Definición de hecho.",
    "maxwell.tier.6.prompt.nino": "¿Cómo lo probamos? ¿Qué 'definición de hecho' nos dice que funciona?",
    "maxwell.tier.7.prompt.cxo": "Lo que no sabes. Suposición más riesgosa (validar primero). Alcance MVP, backlog V2, sueños V3.",
    "maxwell.tier.7.prompt.nino": "¿De qué no estás seguro? ¿Cuál es la suposición más riesgosa? ¿Qué va en v1, v2, v3?",
    "maxwell.list.add": "Agregar",
    "maxwell.list.remove": "Quitar",
    "maxwell.validation.warn": "Atento — hay campos requeridos vacíos:",
    "maxwell.validation.error": "No se puede continuar:",
    "maxwell.validation.continue": "Haz clic en Siguiente otra vez para avanzar de todos modos.",
    "maxwell.out.spec.title": "Spec de Requerimientos",
    "maxwell.out.spec.subtitle": "Generado por MAXWELL-Help-ME — Lorenza · Lopettia.ai",
    "maxwell.out.script.title": "Script para Claude Code",
    "maxwell.out.script.subtitle": "Entrégaselo a Claude Code · única fuente de verdad · no saltes fases",
    "maxwell.out.copy": "Copiar",
    "maxwell.out.copied": "Copiado al portapapeles",
    "maxwell.out.save": "Guardar",
    "maxwell.out.empty": "Llena los tiers de arriba para poblar este artefacto.",
    "maxwell.out.empty.section": "_(sin contenido)_",
    "maxwell.out.skipped": "(saltado)",
    "maxwell.out.untitled": "proyecto-sin-titulo",
    "maxwell.cmp.button": "Validar en CMP Compare",
    "maxwell.restart": "Empezar de nuevo",
    "maxwell.handoff.toCompare": "Spec enviado a Compare — elige modelos y Run.",
    "maxwell.restart.confirm": "¿Descartar el borrador actual del wizard y empezar de nuevo?",
    "maxwell.restart.done": "Wizard reiniciado. Tier 1 activo.",
    /* Coder101 — entrada al Agentic SDLC de Lopettia */
    "coder101.tagline": "Humanos definen intención · Agentes ejecutan · Ops cierran el ciclo",
    "coder101.stage.1": "Intent",
    "coder101.stage.2": "Entender",
    "coder101.stage.gate-a": "Gate A",
    "coder101.stage.3": "Implementar",
    "coder101.stage.gate-b": "Gate B",
    "coder101.stage.4": "Tests",
    "coder101.stage.gate-f": "Final",
    "coder101.stage.6": "Deploy",
    "coder101.stage.7": "Monitor",
    "coder101.stage.8": "Learn",
    "coder101.legend.ai": "Agentes IA",
    "coder101.legend.human": "Humanos",
    "coder101.legend.ops": "Ops",
    "coder101.cta.express": "Express Intent → MAXWELL-Help-ME",
    "coder101.cta.chat": "Chat con Maxwell",
    "coder101.chat.toast": "Modo intake de Maxwell cargado — describe tu intent arriba y Ejecuta.",
    "coder101.poweredby": "Powered by Lopettia.ai · Agentic SDLC",
    "maxwell.chat.title": "MAXWELL-Help-ME · Chat",
    "maxwell.chat.tagline": "Conversa con Maxwell. Maxwell te guía.",
    "maxwell.chat.privacy": "Cono del Silencio activo — la conversación viaja directo a tu cuenta Anthropic con tu BYOK; nada queda en Lopettia.",
    "maxwell.chat.placeholder": "Describe tu necesidad…",
    "maxwell.chat.send": "Enviar",
    "maxwell.chat.typing": "Maxwell está escribiendo…",
    "maxwell.chat.empty": "Empieza la conversación — describe qué necesitas construir.",
    "maxwell.chat.model": "Powered by Anthropic Claude · BYOK",
    "maxwell.chat.reset": "Reiniciar chat",
    "maxwell.chat.reset.confirm": "¿Descartar el historial actual y empezar de nuevo?",
    "maxwell.chat.error.getkey": "Agrega tu clave Anthropic →",
    "cycle.eyebrow": "Agentic SDLC · ciclo de 8 etapas",
    "cycle.title": "Las 8 etapas del ciclo, en detalle",
    "cycle.subtitle": "Cada etapa tiene su pantalla dedicada, su responsable claro, y reglas explícitas de transición. THE LOPETTIA INVERSION: humanos definen intención y gobiernan compuertas · agentes ejecutan · operaciones cierran el ciclo.",
    "cycle.foot.tag": "Mockups · referencia estática",
    "cycle.foot.note": "Phase 0 de las formas del agentic SDLC. §12.1 chat con Maxwell ya está vivo (usa los botones del card Coder101 arriba). Pipeline view, GATE A, GATE B, Revisión Final, Dashboard y Onboarding llegan como surfaces interactivas en próximas phases.",
    "cycle.stage.1.meta": "Etapa 1 · Humano · ~10 min",
    "cycle.stage.1.title": "Express Intent",
    "cycle.stage.1.tagline": "El usuario describe la necesidad a MaxwellHelpMe en lenguaje natural.",
    "cycle.stage.1.body": "Dos caminos: chat con Maxwell (default) o llenar el formulario estructurado MAXWELL-Help-ME. Ambos alimentan al mismo agente de intake y producen el mismo Intent Brief.",
    "cycle.stage.2.meta": "Etapa 2 · Agente IA · 15-60s · claude-opus-5",
    "cycle.stage.2.title": "Agent Understands",
    "cycle.stage.2.tagline": "UnderstandingAgent parsea el brief y produce un plan técnico detallado.",
    "cycle.stage.2.body": "Output: plan en Markdown con arquitectura propuesta (diagramas Mermaid), módulos, dependencias técnicas, riesgos identificados con mitigaciones, estimación de tiempo/costo, planes de testing y rollback.",
    "cycle.gate.a.meta": "Gate A · Humano · SLA 24h",
    "cycle.gate.a.title": "Validación de Plan",
    "cycle.gate.a.tagline": "El reviewer aprueba, edita, pide cambios, o rechaza el plan.",
    "cycle.gate.a.body": "Tabs: Plan Markdown · Diagrama · Riesgos · Estimación. Editor con el plan completo inline. Cada decisión queda auditada con nombre del reviewer e IP.",
    "cycle.stage.3.meta": "Etapa 3 · Agente IA · 5-30 min · claude-opus-5",
    "cycle.stage.3.title": "Agent Implements",
    "cycle.stage.3.tagline": "ImplementationAgent genera el entregable en un workspace Git aislado.",
    "cycle.stage.3.body": "Genera código fuente, integraciones (Oracle EBS, Salesforce, REST APIs), pipelines de datos, documentos técnicos, o análisis según el deliverable type. Cada commit firmado.",
    "cycle.gate.b.meta": "Gate B · Humano · SLA 48h",
    "cycle.gate.b.title": "Code Review",
    "cycle.gate.b.tagline": "Tech Lead / CTO valida el código generado antes de testing.",
    "cycle.gate.b.body": "Diff viewer side-by-side (estilo GitHub PR) con cards de linter, security scan, coverage y warnings. El reviewer aprueba, pide cambios inline, o rechaza.",
    "cycle.stage.4.meta": "Etapa 4 · Agente IA · 5-15 min · claude-sonnet-5",
    "cycle.stage.4.title": "Tests + Docs",
    "cycle.stage.4.tagline": "TestDocAgent genera tests unitarios + integración y documentación completa.",
    "cycle.stage.4.body": "Coverage target ≥80%. Docs generadas: README, API reference, runbook de deployment, ADRs por cada decisión de arquitectura locked.",
    "cycle.gate.f.meta": "Etapa 5 · Humano · SLA configurable",
    "cycle.gate.f.title": "Revisión Humana Final",
    "cycle.gate.f.tagline": "VP / Director / Risk Officer aprueba para deployment.",
    "cycle.gate.f.body": "Checklist de criterios de éxito con badges (CUMPLE / PARCIAL / NO CUMPLE). Aprueba & deploy, Quick Refine (fix de última milla), o rechaza.",
    "cycle.stage.6.meta": "Etapa 6 · Ops · ~5 min · claude-sonnet-5",
    "cycle.stage.6.title": "Deploy + Ship",
    "cycle.stage.6.tagline": "DeploymentAgent provisiona infra, aplica migraciones, despliega al ambiente.",
    "cycle.stage.6.body": "Gate pre-prod: smoke tests en staging. Deploy a producción con GitOps (ArgoCD) y auto-rollback si falla el health-check. Version tagged en Git, manifest firmado.",
    "cycle.stage.7.meta": "Etapa 7 · Ops · continuo · claude-sonnet-5",
    "cycle.stage.7.title": "Monitor + Observabilidad",
    "cycle.stage.7.tagline": "MonitoringAgent vigila trazas OpenTelemetry, métricas Prometheus, audit logs.",
    "cycle.stage.7.body": "Auto-pages en anomalía: breach de p95 latency, spike de error rate, error rate de KMS, audit-chain integrity break. Alerta a Slack/PagerDuty con traceId para triage rápido.",
    "cycle.stage.8.meta": "Etapa 8 · Ops · ongoing · claude-haiku-4.5",
    "cycle.stage.8.title": "Learn + Iterate",
    "cycle.stage.8.tagline": "LearningAgent extrae patrones de ciclos completados para mejorar los futuros.",
    "cycle.stage.8.body": "Minea feedback de reviewers, razones de rechazo de gates, e incidentes post-deploy. Output: mejoras a system prompts (versionadas) y patrones recomendados para intents futuros en el mismo dominio.",
    "cycle.intent.empty": "Empieza la conversación — describe qué necesitas construir o automatizar.",
    "cycle.intent.ready": "{n} mensaje(s) enviado(s). Puedes continuar a Plan cuando estés listo.",
    "cycle.action.continue.plan": "Continuar a Plan",
    "cycle.action.back.intent": "Volver a Intent",
    "cycle.action.back.plan": "Volver a Plan",
    "cycle.action.back.impl": "Volver a Implementation",
    "cycle.action.back.review": "Volver a Code Review",
    "cycle.action.back.tests": "Volver a Tests + Docs",
    "cycle.action.continue.final": "Continuar a Revisión Final",
    "cycle.action.send.review": "Enviar a Code Review",
    "cycle.action.approve.plan": "Aprobar plan y continuar",
    "cycle.action.approve.code": "Aprobar código y continuar",
    "cycle.action.request.changes": "Pedir cambios",
    "cycle.action.reject": "Rechazar",
    "cycle.action.quick.refine": "Quick refine",
    "cycle.action.approve.ship": "🚀 Aprobar y desplegar",
    "cycle.plan.empty": "Haz click en \"Generar plan\" para que el agente analice el chat de la Etapa 1.",
    "cycle.plan.generating": "El UnderstandingAgent está leyendo el chat y produciendo el plan…",
    "cycle.plan.generate": "Generar plan",
    "cycle.plan.regenerate": "Re-generar",
    "cycle.plan.reject.confirm": "¿Rechazar este plan? Tendrás que re-generarlo o refinarlo.",
    "cycle.impl.empty": "Haz click en \"Generar implementación\" para producir el entregable a partir del plan aprobado.",
    "cycle.impl.generating": "El ImplementationAgent está produciendo el entregable…",
    "cycle.impl.generate": "Generar implementación",
    "cycle.impl.regenerate": "Re-generar",
    "cycle.review.empty": "No hay implementación que revisar aún.",
    "cycle.review.changes.prompt": "Describe los cambios que quieres que el agente haga:",
    "cycle.review.reject.confirm": "¿Rechazar esta implementación? El ciclo se detiene en esta etapa.",
    "cycle.tests.empty": "Haz click en \"Generar tests + docs\" para producir cobertura y documentación.",
    "cycle.tests.generating": "El TestDocAgent está produciendo tests y documentación…",
    "cycle.tests.generate": "Generar tests + docs",
    "cycle.tests.regenerate": "Re-generar",
    "cycle.final.summary.intent": "Etapa 1 · Intent",
    "cycle.final.summary.plan":   "Etapa 2 · Plan",
    "cycle.final.summary.impl":   "Etapa 3 · Implementación",
    "cycle.final.summary.review": "Etapa 4 · Code Review",
    "cycle.final.summary.tests":  "Etapa 5 · Tests + Docs",
    "cycle.final.shipped": "Desplegado",
    "cycle.final.shipped.note": "Ciclo completo. El bundle está listo para deployment.",
    "cycle.final.shipped.toast": "Ciclo aprobado y desplegado.",
    "cycle.final.reject.confirm": "¿Rechazar el bundle entero? El ciclo termina aquí.",
    "cycle.final.refine.prompt": "¿Qué necesita un fix de última milla antes de desplegar?",
    "cycle.final.ship.confirm": "¿Aprobar y desplegar este bundle?",
    "cycle.reset": "Reiniciar ciclo",
    "cycle.reset.confirm": "¿Descartar el ciclo actual (intent + plan + implementación + tests) y empezar de nuevo?",
    "cycle.reset.done": "Ciclo reiniciado.",
  },
  pt: {
    "demo.cta": "Demo",
    "auth.signin": "Entrar",
    "auth.register": "Começar grátis",
    "picker.pickFree.btn":   "Escolher 4 grátis",
    "picker.pickPaid.btn":   "Escolher 4 pagos",
    "picker.pickPaid.toast": "Selecionados os 4 melhores modelos pagos. Adicione as chaves dos provedores correspondentes.",
    "picker.pickFree.toast": "Selecionados os 4 melhores modelos grátis. Adicione suas chaves Groq + OpenRouter em Settings para rodar.",
    "session.open.btn":        "Abrir sessão",
    "session.save.btn":        "Salvar sessão",
    "session.empty":           "Nada para salvar — escreva um prompt ou rode uma comparação primeiro.",
    "session.saved":           "Sessão salva.",
    "session.loaded":          "Sessão carregada.",
    "session.parse_error":     "Não consegui parsear esse arquivo — é um JSON de sessão AI Board válido?",
    "session.invalid":         "Esse arquivo não é uma sessão AI Board (falta o campo 'format').",
    "session.replace_confirm": "Carregar esta sessão vai substituir seu prompt, modelos e respostas atuais. Continuar?",
    "session.cloud.history":       "Histórico na nuvem",
    "session.cloud.save":          "Salvar na nuvem",
    "session.cloud_save_name":     "Salvar esta sessão como:",
    "session.cloud_saved":         "Salva na nuvem.",
    "session.cloud_empty":         "Ainda não há sessões salvas. Clique em '☁️ Salvar' enquanto trabalha para salvar uma.",
    "session.cloud_login_required": "Faça login para ativar o histórico na nuvem.",
    "session.cloud_quota":         "Cota de armazenamento cheia. Faça upgrade para continuar salvando.",
    /* ----- Páginas de autenticação ----- */
    "auth.login.eyebrow":      "CONTA · ENTRAR",
    "auth.login.title":        "Entrar",
    "auth.login.sub":          "Bem-vindo. Use sua conta AI Board para continuar.",
    "auth.login.submit":       "Entrar",
    "auth.login.forgot":       "Esqueceu sua senha?",
    "auth.login.no_account":   "Novo por aqui?",
    "auth.login.register_cta": "Criar conta",
    "auth.register.eyebrow":      "CONTA · NOVA",
    "auth.register.title":        "Crie sua conta",
    "auth.register.sub":          "Teste Pro de 14 dias. Sem cartão. Cancele quando quiser.",
    "auth.register.submit":       "Criar conta",
    "auth.register.terms":        "Aceito os Termos e a Política de Privacidade",
    "auth.register.have_account": "Já tem conta?",
    "auth.register.signin_cta":   "Entrar",
    "auth.forgot.eyebrow": "CONTA · RECUPERAÇÃO",
    "auth.forgot.title":   "Esqueci minha senha",
    "auth.forgot.sub":     "Vamos te enviar um link único por e-mail para redefinir.",
    "auth.forgot.submit":  "Enviar link",
    "auth.forgot.back":    "Voltar para entrar",
    "auth.reset.eyebrow": "CONTA · REDEFINIR",
    "auth.reset.title":   "Defina uma nova senha",
    "auth.reset.sub":     "Escolha uma nova senha. Mínimo 8 caracteres.",
    "auth.reset.submit":  "Definir nova senha",
    "auth.reset.back":    "Voltar para entrar",
    "auth.verify.eyebrow":       "CONTA · VERIFICAR E-MAIL",
    "auth.verify.pending_title": "Verificando…",
    "auth.verify.pending_sub":   "Verifique o link do e-mail que enviamos.",
    "auth.verify.continue":      "Continuar para AI Board",
    "auth.verify.go_signin":     "Entrar",
    "auth.verify.go_register":   "Criar conta",
    "auth.account.eyebrow":         "CONTA",
    "auth.account.title":           "Conta",
    "auth.account.sub":             "Sua conta, seus dados, seu controle.",
    "auth.account.loading_title":   "Um momento",
    "auth.account.loading_sub":     "Carregando sua conta…",
    "auth.account.meta":            "Detalhes da conta",
    "auth.account.row.email":       "E-mail",
    "auth.account.row.name":        "Nome",
    "auth.account.row.tier":        "Plano",
    "auth.account.row.status":      "Status",
    "auth.account.row.verified":    "E-mail verificado",
    "auth.account.row.renews":      "Renova",
    "auth.account.manage":          "Gerenciar assinatura",
    "auth.account.pricing":         "Ver preços",
    "auth.account.history":         "Histórico de interações",
    "auth.account.resend":          "Reenviar verificação",
    "auth.account.resend_long":     "Reenviar e-mail de verificação",
    "auth.account.change_password": "Trocar senha",
    "auth.account.logout":          "Sair",
    "auth.account.verify_strong":   "Verifique seu e-mail",
    "auth.account.verify_msg":      "Verifique seu e-mail para começar seu teste de 14 dias.",
    "auth.pricing.eyebrow": "PREÇOS",
    "auth.pricing.title":   "Planos",
    "auth.pricing.sub":     "Demo grátis para sempre. BYOK real a partir do Pro.",
    "auth.pricing.loading": "Carregando planos…",
    "auth.pricing.monthly": "Mensal",
    "auth.pricing.yearly":  "Anual",
    "auth.pricing.save":    "Economize ~17%",
    "auth.pricing.note":    "Chaves BYOK nunca saem do navegador. Cancele quando quiser.",
    "auth.field.email":            "E-mail",
    "auth.field.password":         "Senha",
    "auth.field.new_password":     "Nova senha",
    "auth.field.confirm_password": "Confirmar senha",
    "auth.field.display_name":     "Nome (opcional)",
    "footer.byok_short": "BYOK — as chaves nunca saem do navegador.",
    "brand.product": "Compare",
    "hero.eyebrow": "Lorenza · Superfície Compare",
    "hero.title.1": "Compare.",
    "hero.title.2": "Sintetize.",
    "hero.title.3": "Decida.",
    "hero.subtitle": "Uma caixa para cada modelo. Execute múltiplos motores de IA em paralelo e combine o melhor de cada um em uma resposta unificada — com o modelo e método que você escolher.",
    "hero.tag": "Inteligência · Estratégia · Valor · Eficiência",
    "hero.caption": "Agentes de IA · Trabalhando para gerar valor",
    "picker.title": "Modelos · Constelação",
    "picker.selected": "selecionados",
    "picker.empty": "Nenhum modelo selecionado — clique em um nó",
    "picker.hint": "Clique em um nó para selecionar. Modelos selecionados orbitam mais perto da íris.",
    "prompt.title": "Prompt",
    "prompt.placeholder": "Pergunte qualquer coisa. O mesmo prompt será enviado a cada modelo selecionado.",
    "prompt.chars": "caracteres",
    "prompt.hint": "para executar",
    "prompt.run": "Executar",
    "prompt.open": "Abrir",
    "prompt.save": "Salvar",
    "prompt.loaded": "Carregado {name}",
    "prompt.loadfail": "Não foi possível ler o arquivo",
    "prompt.toobig": "Arquivo muito grande — máx. 1 MB",
    "export.txt": "Texto simples",
    "responses.title": "Respostas",
    "synth.title": "Síntese · Consolidar",
    "synth.meta": "Escolha como e com qual modelo",
    "synth.mode.label": "Modo de síntese (como)",
    "synth.with.label": "Modelo sintetizador (com qual)",
    "synth.button": "Sintetizar",
    "synth.empty": "Escolha um modo de síntese e um modelo — depois combine o melhor de cada resposta em uma só.",
    "synth.custom.label": "Instruções personalizadas de síntese",
    "synth.custom.placeholder": "Ex.: Sintetize como memo de conselho: 1 conclusão, 3 riscos, 1 próximo passo recomendado. Saída em português.",
    "synth.prompt.wrap": "Abaixo estão respostas de {n} modelos de IA diferentes ao mesmo prompt do usuário.\n\nPROMPT ORIGINAL:\n{prompt}\n\nRESPOSTAS DOS MODELOS:\n{responses}\n\nINSTRUÇÃO:\n{instruction}\n\nNão liste nem atribua os modelos. Retorne apenas a resposta sintetizada.",
    "settings.title": "Chaves API · Vault",
    "settings.sub": "Traga suas próprias chaves",
    "settings.security_strong": "Apenas local.",
    "settings.security": "Suas chaves são armazenadas apenas neste navegador (localStorage). Cada chamada vai diretamente do seu navegador ao provedor — nunca aos servidores da Lopettia.",
    "settings.clear": "Apagar todas as chaves",
    "settings.cleared": "Todas as chaves apagadas",
    "settings.notset": "Não configurada",
    "settings.set": "Configurada",
    "settings.getkey": "Obter chave",
    "settings.test": "Testar",
    "settings.testing": "Testando…",
    "settings.test.ok": "Conectado · {n} modelos disponíveis",
    "settings.test.allok": "Todos os {n} modelos configurados estão disponíveis",
    "settings.test.partial": "{ok} de {total} modelos configurados disponíveis",
    "settings.test.missing": "Não disponíveis com esta chave",
    "settings.test.show": "Ver todos os modelos disponíveis",
    "settings.resetspent": "Reiniciar gasto da sessão",
    "settings.spent.reset": "Gasto da sessão reiniciado para $0",
    "cost.legend": "Escala de custo",
    "cost.session": "Gasto da sessão:",
    "cost.total": "Total da sessão",
    "cost.total.tooltip": "Gasto estimado total em todos os modelos nesta sessão do navegador",
    "cost.select": "Clique para selecionar",
    "cost.deselect": "Clique para desmarcar",
    "cost.disclaimer": "O gasto é estimado pelo preço público × tokens usados. O saldo real só é visível no console de billing de cada provedor.",
    "autosave.heading":       "Autosalvamento de sessão",
    "autosave.help":          "Quando ativo, seu prompt + respostas + síntese são salvos automaticamente após cada fan-out, síntese e exportação.",
    "autosave.cloud_label":   "Salvar na nuvem",
    "autosave.cloud_help":    "Um blob diário no seu histórico cloud — sobrescreve no lugar, sem encher a cota.",
    "autosave.cloud_on":      "Autosalvamento na nuvem ativado — vai gravar na próxima interação.",
    "autosave.cloud_off":     "Autosalvamento na nuvem desativado.",
    "autosave.cloud_quota":   "Autosalvamento na nuvem pausado: cota de armazenamento atingida.",
    "autosave.local_label":   "Salvar em arquivo local",
    "autosave.local_help":    "Você escolhe o arquivo .json uma vez; cada interação o sobrescreve silenciosamente. Só Chrome/Edge.",
    "autosave.local_on":      "Autosalvamento local ativado — será pedido escolher um arquivo na próxima interação.",
    "autosave.local_off":     "Autosalvamento local desativado.",
    "autosave.local_unsupported": "O autosalvamento local precisa de Chrome ou Edge. Use o cloud ou salve manualmente.",
    "attach.tooltip":         "Anexar arquivos (texto, Word, PowerPoint, PDF, imagens)",
    "attach.button":          "Anexar",
    "attach.added":           "Anexados {count} arquivo(s).",
    "attach.too_big":         "{name} é maior que {max} — ignorado.",
    "attach.docx_failed":     "Não foi possível ler {name}.",
    "attach.pptx_failed":     "Não foi possível ler {name}.",
    "attach.clear_all":       "Remover todos",
    "mic.tooltip":            "Ditar o prompt (Chrome/Edge/Safari)",
    "mic.tooltip_stop":       "Parar ditado",
    "mic.button":             "Ditar",
    "mic.button_stop":        "Parar",
    "mic.unsupported":        "O ditado por voz precisa de Chrome, Edge ou Safari.",
    "mic.permission_denied":  "Permissão de microfone negada. Habilite no navegador e tente novamente.",
    "mic.network":            "Erro de rede no reconhecimento de voz. Verifique sua conexão e tente novamente.",
    "mic.error":              "Falha no reconhecimento de voz",
    "footer.note": "BYOK — suas chaves nunca saem deste navegador. Chamadas vão direto para cada provedor.",
    "err.nomodels": "Selecione ao menos um modelo.",
    "err.noprompt": "Digite um prompt primeiro.",
    "err.nokey": "Sem chave de API para {provider}. Abra as Configurações para adicionar.",
    "err.nocustom": "Digite instruções personalizadas ou escolha outro modo.",
    "err.lowbalance": "A conta de {provider} não tem saldo suficiente. Adicione método de pagamento ou recarregue para continuar.",
    "err.invalidkey": "A chave de API de {provider} é inválida ou foi revogada. Verifique Configurações e cole uma chave atual.",
    "err.ratelimit": "Limite de taxa de {provider} atingido. Aguarde um momento e tente novamente.",
    "err.model": "{provider} reportou problema com o modelo: {raw}",
    "err.forbidden": "{provider} recusou esta solicitação: {raw}",
    "err.fix_link": "Resolver",
    "err.show_raw": "Ver resposta crua",
    "prompt.no_models": "nenhum modelo",
    "prompt.model": "modelo",
    "prompt.models": "modelos",
    "responses.summary": "{ok} de {total} com sucesso · {ms}ms",
    "responses.summary.partial": "{ok} de {total} respostas",
    "run.this": "Executar este modelo",
    "run.pending": "Pendente",
    "run.pending.msg": "Adicionado após a última execução. Clique abaixo para executar este modelo com o prompt atual.",
    "save.this": "Salvar esta resposta",
    "save.all": "Exportar todas",
    "save.synth": "Exportar síntese",
    "export.md": "Markdown",
    "export.docx": "Documento Word",
    "export.pdf": "Documento PDF",
    "export.xlsx": "Planilha Excel",
    "export.pptx.section": "Apresentação PowerPoint",
    "export.pptx.detailed": "Detalhada (um slide por modelo)",
    "export.pptx.summary": "Resumo (condensada)",
    "export.pptx.executive": "Executiva (apenas conclusão)",
    "export.section.prompt": "Prompt",
    "export.section.responses": "Respostas",
    "export.section.synthesis": "Síntese",
    "export.section.sources": "Modelos fonte",
    "export.section.original": "Prompt Original",
    "export.section.optimal": "Prompt Ideal",
    "export.section.optimal.sub": "Engenharia reversa do modo de síntese: {mode}",
    "export.libmissing": "Biblioteca de exportação {fmt} não carregada — verifique sua conexão",
    "export.failed": "Falha na exportação para {fmt}",
    "save.done": "{name} salvo",
    "save.all.done": "Todas as respostas salvas",
    "save.synth.done": "Síntese salva",
    "save.optimal.done": "Prompt ideal salvo",
    "save.nothing": "Ainda não há nada para salvar",
    "copy.synth": "Copiar",
    "copy.done": "Copiado para a área de transferência",
    "copy.failed": "Falha ao copiar",
    "optimal.title": "Prompt Ideal · Reutilizável",
    "optimal.meta": "Para uso direto em uma única passagem",
    "optimal.intro": "Lorenza pode fazer engenharia reversa do prompt que — usado diretamente com um modelo — produziria uma resposta próxima da sua síntese. Salve para uso futuro de tiro único, sem comparação.",
    "optimal.button": "Gerar prompt ideal",
    "optimal.generating": "Gerando…",
    "optimal.placeholder": "O prompt ideal aparecerá aqui. Você pode editá-lo antes de salvá-lo ou usá-lo.",
    "optimal.edit": "Editar",
    "optimal.editing": "Pronto",
    "optimal.copy": "Copiar",
    "optimal.save": "Salvar",
    "optimal.use": "Usar este prompt",
    "optimal.used": "Carregado no prompt — pronto para executar",
    /* MAXWELL-Help-ME — wizard guiado de requisitos (tema Get Smart) */
    "maxwell.panel.title": "MAXWELL-Help-ME",
    "maxwell.panel.tagline": "Defina a missão. Maxwell guia.",
    "maxwell.mode.nino": "Criança",
    "maxwell.mode.cxo": "CXO",
    "maxwell.back": "Voltar para Compare",
    "maxwell.cone.label": "Cone do Silêncio ativo — seu rascunho fica só neste navegador.",
    "maxwell.next": "Próximo →",
    "maxwell.prev": "← Anterior",
    "maxwell.skip": "Pular",
    "maxwell.summary.edit": "EDITAR",
    "maxwell.summary.fill": "PREENCHER",
    "maxwell.tier.1.title": "Por quê · Visão e Propósito",
    "maxwell.tier.2.title": "Quem e o quê · Usuários, Escopo, Limites",
    "maxwell.tier.3.title": "Como · Comportamento, Lógica, Dados",
    "maxwell.tier.4.title": "Experiência · UX, Fluxos, Tom",
    "maxwell.tier.5.title": "Stack · Escolhas Técnicas",
    "maxwell.tier.6.title": "Validação · Testes e Qualidade",
    "maxwell.tier.7.title": "Incógnitas e Futuro · Honestidade e Iteração",
    "maxwell.tier.1.prompt.cxo": "Qual dor ou ineficiência ataca? Objetivo em uma frase + como medir sucesso + o que NUNCA deve fazer.",
    "maxwell.tier.1.prompt.nino": "Que coisa chata isso resolve? Uma frase, direto. E o que NUNCA deve fazer?",
    "maxwell.tier.2.prompt.cxo": "Usuários principais e nível técnico. 3-5 must-haves não negociáveis. 3-5 fora-de-escopo explícitos.",
    "maxwell.tier.2.prompt.nino": "Quem usa? Quais 3-5 coisas deve fazer? O que NUNCA deve fazer?",
    "maxwell.tier.3.prompt.cxo": "Modelo de dados (entidades + ciclo de vida), regras e validação, erros e casos limite + estratégia de recuperação.",
    "maxwell.tier.3.prompt.nino": "Que coisas lembra? Regras: se X, então Y. O que acontece quando algo falha?",
    "maxwell.tier.4.prompt.cxo": "Caminho feliz passo a passo. 3+ caminhos alternativos. Tom, design system, acessibilidade (WCAG 2.1 AA?).",
    "maxwell.tier.4.prompt.nino": "Me conte o primeiro uso perfeito, passo a passo. E se o usuário muda de ideia?",
    "maxwell.tier.5.prompt.cxo": "Frontend, backend, banco, hosting, auth, integrações. Ou: 'Claude, recomenda o stack mais simples viável'.",
    "maxwell.tier.5.prompt.nino": "De que peças deve ser feito? Se não sabe, escreva 'Claude, recomenda'.",
    "maxwell.tier.6.prompt.cxo": "Casos de teste (entrada → saída esperada). Benchmarks. Monitoramento. Plano de rollback. Definição de pronto.",
    "maxwell.tier.6.prompt.nino": "Como testamos isto? Que 'definição de pronto' diz que funciona?",
    "maxwell.tier.7.prompt.cxo": "O que não sabe. Suposição mais arriscada (validar primeiro). Escopo MVP, backlog V2, sonhos V3.",
    "maxwell.tier.7.prompt.nino": "Do que não tem certeza? Qual a suposição mais arriscada? O que vai em v1, v2, v3?",
    "maxwell.list.add": "Adicionar",
    "maxwell.list.remove": "Remover",
    "maxwell.validation.warn": "Atenção — há campos obrigatórios vazios:",
    "maxwell.validation.error": "Não é possível continuar:",
    "maxwell.validation.continue": "Clique em Próximo novamente para avançar mesmo assim.",
    "maxwell.out.spec.title": "Spec de Requisitos",
    "maxwell.out.spec.subtitle": "Gerado por MAXWELL-Help-ME — Lorenza · Lopettia.ai",
    "maxwell.out.script.title": "Script para Claude Code",
    "maxwell.out.script.subtitle": "Entregue ao Claude Code · única fonte de verdade · não pule fases",
    "maxwell.out.copy": "Copiar",
    "maxwell.out.copied": "Copiado para a área de transferência",
    "maxwell.out.save": "Salvar",
    "maxwell.out.empty": "Preencha os tiers acima para popular este artefato.",
    "maxwell.out.empty.section": "_(sem conteúdo)_",
    "maxwell.out.skipped": "(pulado)",
    "maxwell.out.untitled": "projeto-sem-titulo",
    "maxwell.cmp.button": "Validar no CMP Compare",
    "maxwell.restart": "Recomeçar",
    "maxwell.handoff.toCompare": "Spec enviado para Compare — escolha modelos e Run.",
    "maxwell.restart.confirm": "Descartar o rascunho atual do wizard e recomeçar?",
    "maxwell.restart.done": "Wizard reiniciado. Tier 1 ativo.",
    /* Coder101 — entrada ao Agentic SDLC da Lopettia */
    "coder101.tagline": "Humanos definem intenção · Agentes executam · Ops fecham o ciclo",
    "coder101.stage.1": "Intent",
    "coder101.stage.2": "Entender",
    "coder101.stage.gate-a": "Gate A",
    "coder101.stage.3": "Implementar",
    "coder101.stage.gate-b": "Gate B",
    "coder101.stage.4": "Tests",
    "coder101.stage.gate-f": "Final",
    "coder101.stage.6": "Deploy",
    "coder101.stage.7": "Monitor",
    "coder101.stage.8": "Learn",
    "coder101.legend.ai": "Agentes IA",
    "coder101.legend.human": "Humanos",
    "coder101.legend.ops": "Ops",
    "coder101.cta.express": "Express Intent → MAXWELL-Help-ME",
    "coder101.cta.chat": "Chat com Maxwell",
    "coder101.chat.toast": "Modo intake do Maxwell carregado — descreva seu intent acima e Execute.",
    "coder101.poweredby": "Powered by Lopettia.ai · Agentic SDLC",
    "maxwell.chat.title": "MAXWELL-Help-ME · Chat",
    "maxwell.chat.tagline": "Converse com Maxwell. Maxwell guia.",
    "maxwell.chat.privacy": "Cone do Silêncio ativo — a conversa vai direto à sua conta Anthropic via sua chave BYOK; nada fica na Lopettia.",
    "maxwell.chat.placeholder": "Descreva sua necessidade…",
    "maxwell.chat.send": "Enviar",
    "maxwell.chat.typing": "Maxwell está digitando…",
    "maxwell.chat.empty": "Comece a conversa — descreva o que você precisa construir.",
    "maxwell.chat.model": "Powered by Anthropic Claude · BYOK",
    "maxwell.chat.reset": "Reiniciar chat",
    "maxwell.chat.reset.confirm": "Descartar o histórico atual e recomeçar?",
    "maxwell.chat.error.getkey": "Adicione sua chave Anthropic →",
    "cycle.eyebrow": "Agentic SDLC · ciclo de 8 etapas",
    "cycle.title": "As 8 etapas do ciclo, em detalhe",
    "cycle.subtitle": "Cada etapa tem sua tela dedicada, seu responsável claro, e regras explícitas de transição. THE LOPETTIA INVERSION: humanos definem intenção e governam gates · agentes executam · operações fecham o ciclo.",
    "cycle.foot.tag": "Mockups · referência estática",
    "cycle.foot.note": "Phase 0 das formas do agentic SDLC. §12.1 chat com Maxwell já está vivo (use os botões do card Coder101 acima). Pipeline view, GATE A, GATE B, Revisão Final, Dashboard e Onboarding chegam como surfaces interativas em próximas phases.",
    "cycle.stage.1.meta": "Etapa 1 · Humano · ~10 min",
    "cycle.stage.1.title": "Express Intent",
    "cycle.stage.1.tagline": "O usuário descreve a necessidade ao MaxwellHelpMe em linguagem natural.",
    "cycle.stage.1.body": "Dois caminhos: chat com Maxwell (default) ou preencher o formulário estruturado MAXWELL-Help-ME. Ambos alimentam o mesmo agente de intake e produzem o mesmo Intent Brief.",
    "cycle.stage.2.meta": "Etapa 2 · Agente IA · 15-60s · claude-opus-5",
    "cycle.stage.2.title": "Agent Understands",
    "cycle.stage.2.tagline": "UnderstandingAgent parseia o brief e produz um plano técnico detalhado.",
    "cycle.stage.2.body": "Output: plano em Markdown com arquitetura proposta (diagramas Mermaid), módulos, dependências técnicas, riscos identificados com mitigações, estimativa de tempo/custo, planos de testing e rollback.",
    "cycle.gate.a.meta": "Gate A · Humano · SLA 24h",
    "cycle.gate.a.title": "Validação de Plano",
    "cycle.gate.a.tagline": "O reviewer aprova, edita, solicita mudanças, ou rejeita o plano.",
    "cycle.gate.a.body": "Tabs: Plan Markdown · Diagrama · Riscos · Estimativa. Editor com o plano completo inline. Cada decisão é auditada com nome do reviewer e IP.",
    "cycle.stage.3.meta": "Etapa 3 · Agente IA · 5-30 min · claude-opus-5",
    "cycle.stage.3.title": "Agent Implements",
    "cycle.stage.3.tagline": "ImplementationAgent gera o entregável em um workspace Git isolado.",
    "cycle.stage.3.body": "Gera código fonte, integrações (Oracle EBS, Salesforce, REST APIs), pipelines de dados, documentos técnicos, ou análises conforme o deliverable type. Cada commit assinado.",
    "cycle.gate.b.meta": "Gate B · Humano · SLA 48h",
    "cycle.gate.b.title": "Code Review",
    "cycle.gate.b.tagline": "Tech Lead / CTO valida o código gerado antes do testing.",
    "cycle.gate.b.body": "Diff viewer side-by-side (estilo GitHub PR) com cards de linter, security scan, coverage e warnings. O reviewer aprova, solicita mudanças inline, ou rejeita.",
    "cycle.stage.4.meta": "Etapa 4 · Agente IA · 5-15 min · claude-sonnet-5",
    "cycle.stage.4.title": "Tests + Docs",
    "cycle.stage.4.tagline": "TestDocAgent gera tests unitários + integração e documentação completa.",
    "cycle.stage.4.body": "Coverage alvo ≥80%. Docs geradas: README, API reference, runbook de deployment, ADRs para cada decisão de arquitetura travada.",
    "cycle.gate.f.meta": "Etapa 5 · Humano · SLA configurável",
    "cycle.gate.f.title": "Revisão Humana Final",
    "cycle.gate.f.tagline": "VP / Diretor / Risk Officer aprova para deployment.",
    "cycle.gate.f.body": "Checklist de critérios de sucesso com badges (CUMPRE / PARCIAL / NÃO CUMPRE). Aprova & deploy, Quick Refine (fix de última milha), ou rejeita.",
    "cycle.stage.6.meta": "Etapa 6 · Ops · ~5 min · claude-sonnet-5",
    "cycle.stage.6.title": "Deploy + Ship",
    "cycle.stage.6.tagline": "DeploymentAgent provisiona infra, aplica migrações, deploya ao ambiente.",
    "cycle.stage.6.body": "Gate pre-prod: smoke tests em staging. Deploy a produção com GitOps (ArgoCD) e auto-rollback se health-check falha. Version tagged em Git, manifest assinado.",
    "cycle.stage.7.meta": "Etapa 7 · Ops · contínuo · claude-sonnet-5",
    "cycle.stage.7.title": "Monitor + Observabilidade",
    "cycle.stage.7.tagline": "MonitoringAgent vigia traces OpenTelemetry, métricas Prometheus, audit logs.",
    "cycle.stage.7.body": "Auto-pages em anomalia: breach de p95 latency, spike de error rate, error rate de KMS, audit-chain integrity break. Alerta a Slack/PagerDuty com traceId para triage rápido.",
    "cycle.stage.8.meta": "Etapa 8 · Ops · ongoing · claude-haiku-4.5",
    "cycle.stage.8.title": "Learn + Iterate",
    "cycle.stage.8.tagline": "LearningAgent extrai padrões de ciclos completados para melhorar os futuros.",
    "cycle.stage.8.body": "Minera feedback de reviewers, razões de rejeição de gates, e incidentes pós-deploy. Output: melhorias a system prompts (versionadas) e padrões recomendados para intents futuros no mesmo domínio.",
    "cycle.intent.empty": "Comece a conversa — descreva o que precisa construir ou automatizar.",
    "cycle.intent.ready": "{n} mensagem(ns) enviada(s). Pode continuar para Plan quando quiser.",
    "cycle.action.continue.plan": "Continuar para Plan",
    "cycle.action.back.intent": "Voltar para Intent",
    "cycle.action.back.plan": "Voltar para Plan",
    "cycle.action.back.impl": "Voltar para Implementation",
    "cycle.action.back.review": "Voltar para Code Review",
    "cycle.action.back.tests": "Voltar para Tests + Docs",
    "cycle.action.continue.final": "Continuar para Revisão Final",
    "cycle.action.send.review": "Enviar para Code Review",
    "cycle.action.approve.plan": "Aprovar plano e continuar",
    "cycle.action.approve.code": "Aprovar código e continuar",
    "cycle.action.request.changes": "Pedir mudanças",
    "cycle.action.reject": "Rejeitar",
    "cycle.action.quick.refine": "Quick refine",
    "cycle.action.approve.ship": "🚀 Aprovar e fazer deploy",
    "cycle.plan.empty": "Clique em \"Gerar plano\" para o agente analisar o chat da Etapa 1.",
    "cycle.plan.generating": "O UnderstandingAgent está lendo o chat e produzindo o plano…",
    "cycle.plan.generate": "Gerar plano",
    "cycle.plan.regenerate": "Re-gerar",
    "cycle.plan.reject.confirm": "Rejeitar este plano? Terá que re-gerá-lo ou refiná-lo.",
    "cycle.impl.empty": "Clique em \"Gerar implementação\" para produzir o entregável a partir do plano aprovado.",
    "cycle.impl.generating": "O ImplementationAgent está produzindo o entregável…",
    "cycle.impl.generate": "Gerar implementação",
    "cycle.impl.regenerate": "Re-gerar",
    "cycle.review.empty": "Não há implementação para revisar ainda.",
    "cycle.review.changes.prompt": "Descreva as mudanças que quer que o agente faça:",
    "cycle.review.reject.confirm": "Rejeitar esta implementação? O ciclo para nesta etapa.",
    "cycle.tests.empty": "Clique em \"Gerar tests + docs\" para produzir cobertura e documentação.",
    "cycle.tests.generating": "O TestDocAgent está produzindo tests e documentação…",
    "cycle.tests.generate": "Gerar tests + docs",
    "cycle.tests.regenerate": "Re-gerar",
    "cycle.final.summary.intent": "Etapa 1 · Intent",
    "cycle.final.summary.plan":   "Etapa 2 · Plan",
    "cycle.final.summary.impl":   "Etapa 3 · Implementation",
    "cycle.final.summary.review": "Etapa 4 · Code Review",
    "cycle.final.summary.tests":  "Etapa 5 · Tests + Docs",
    "cycle.final.shipped": "Deployado",
    "cycle.final.shipped.note": "Ciclo completo. O bundle está pronto para deployment.",
    "cycle.final.shipped.toast": "Ciclo aprovado e deployado.",
    "cycle.final.reject.confirm": "Rejeitar o bundle inteiro? O ciclo termina aqui.",
    "cycle.final.refine.prompt": "O que precisa de fix de última milha antes do deploy?",
    "cycle.final.ship.confirm": "Aprovar e fazer deploy deste bundle?",
    "cycle.reset": "Reiniciar ciclo",
    "cycle.reset.confirm": "Descartar o ciclo atual (intent + plan + implementação + tests) e recomeçar?",
    "cycle.reset.done": "Ciclo reiniciado.",
  },
};

export default I18N;
